<template>
    <form-page
        class="account-overview"
        :title="$route.meta.header"
		:routeBack="routeBack"
		:loading="accountDetailsLoading"
        v-if="accountDetails.id"
    >
        <div slot="nav">
            <nav>
                <ul class="tabs">
                    <li class="tab">
                        <label>
                            <input
                                type="radio"
                                :value="1"
                                v-model="activeView"
                            >

                            <span>
                                Account Summary
                            </span>
                        </label>
                    </li>

                    <!-- <li
						class="tab"
						v-if="accountDetails.status"
					>
                        <label>
                            <input
                                type="radio"
                                :value="2"
                                v-model="activeView"
								v-if="!!accountDetails.status"
                            >

                            <span>
                                Account Session
                            </span>
                        </label>
                    </li>

                    <li
						class="tab" 
						v-if="accountDetails.status"
					>
                        <label>
                            <input
                                type="radio"
                                :value="3"
                                v-model="activeView"
                            >

                            <span>
                                Account Activity
                            </span>
                        </label>
                    </li> -->
                </ul>
            </nav>
        </div>

        <div class="content" slot="content">
                <account-overview-details v-show="activeView === 1"/>

                <!-- <account-session v-show="activeView === 2" />

                <account-overview-activity v-show="activeView === 3" /> -->
            
            <transition name="transition-anim">
                <Modal v-if="modalName.indexOf('edit-account') > -1">
                    <AccountForm storeModule="accountOverview" slot="content"/>
                </Modal>
            </transition>
        </div>
    </form-page>
</template>
 
<script>
import { mapFields } from 'vuex-map-fields'
import AccountOverviewDetails from '@/components/account-overview/AccountOverviewDetails'
// import AccountSession from '@/components/account-overview/AccountSession'
import AccountForm from '@/components/layouts/AccountForm'
import FormPage from '@/components/layouts/FormPage'
// import AccountOverviewActivity from '@/components/account-overview/AccountOverviewActivity'

import * as accountOverview from '@/store/account-overview/app.js'
import * as accountForm from '@/store/account-form/app.js'
export default {
    beforeRouteEnter (to, from, next) {
        to.meta.breadcrumb.homeLink = from.path
        next()
    },

    beforeCreate () {
        if (!this.$store._modulesNamespaceMap['accountOverview/']) {
			this.$store.registerModule('accountOverview', accountOverview.default)
        }
        
        if (!this.$store._modulesNamespaceMap['accountForm/']) {
			this.$store.registerModule('accountForm', accountForm.default)
		}
	},
	
	created () {
		this.$store.dispatch('accountOverview/getAccountDetails', `/cms/client/view?id=${this.$route.params.id}`)
	},

    destroyed() {
        this.$store.commit('accountOverview/clearOverview')
        this.$store.commit('accountOverview/clearList')
    },


    data () {
        return {
            activeView: 1
        }
    },

    computed: {
        name() {
            return this.data 
        },

        ...mapFields('modal', [
            'modalName',
		]),

        ...mapFields('accountOverview', [
			'accountDetails',
			'accountDetailsLoading'
		]),
		
		routeBack () {
			if (this.accountDetails.status) {
				return '/registered-accounts'
			}
			return '/account-request'
		}
    },

    components: {
        AccountForm,
        AccountOverviewDetails,
        // AccountSession,
        FormPage,
        // AccountOverviewActivity,

        Modal: () => import('@/components/utils/Modal'),
    },
}
</script>

<style lang="scss" scoped>
.account-overview {
    height: 100%;
    width: 100%;

    nav {
        width: 100%;
        background-color: #F5F6FA;
        margin-bottom: 10px;
    }

    .tabs {
        display: flex;

        .tab {
            padding-top: 20px;
            display: inline-block;
            margin-right: 50px;
            color: #D8DEEB;

            span {
                padding: 10px 0;
                border-bottom: 1px solid transparent;
            }

            &:hover,
            label > input[type=radio]:checked + span {
                color: #2DC4B6;
                font-weight: 600;
                border-color: #2DC4B6;
            }

            label {
                font-weight: 400;
                cursor: pointer;
                position: relative;

                input {
                    position: absolute;
                    top: 0;
                    left: 0;
                    opacity: 0;
                }
            }
        }
    }

    .content {
        height: 100%;
    }
}
</style>